import React from "react";
import { useParams } from "react-router-dom";

import StoreDetail from "../store/StoreDetail";
import EatsAdminLayout from "./EatsAdminLayout";

const EatsAdminStoreDetailPage = () => {
  const { storeId } = useParams();

  return (
    <EatsAdminLayout activeTab="stores" flushMain>
      <StoreDetail storeId={storeId} embeddedInAdmin />
    </EatsAdminLayout>
  );
};

export default EatsAdminStoreDetailPage;
